/**
* @Author: Michael Neumair <mBook>
* @Date:   2016-09-20T12:22:03+02:00
* @Email:  7q7w7e7r@gmail.com
* @Last modified by:   mBook
* @Last modified time: 2016-09-20T12:44:05+02:00
*/


import React, {Component} from 'react';
import PropTypes from 'prop-types';
import AIconInline, {sizes} from 'common/icons/components/AIconInline';

/**
 * AButtonIconHelp - …
**/
class AButtonIconHelp extends Component {
  /**
     * react render() <AButtonIconHelp>
     *
     * @return {object}
     */
  render() {
    const {
      label,
      icon,
      onPress,
    } = this.props;

    const labelEl = (!label) ? null
            : (<span className="a-button-icon-help__label">{label}</span>);

    return (
      <button
        data-rh=""
        data-rh-at="right"
        tabIndex="-1"
        className="a-button a-button-icon-help"
        onClick={onPress}
      >
        {labelEl}
        <AIconInline size={sizes.tiny}>{icon}</AIconInline>
      </button>
    );
  }
}

AButtonIconHelp.propTypes = {
  label: PropTypes.string,
  icon: PropTypes.string.isRequired,
  onPress: PropTypes.func,
  helpId: PropTypes.string,
  showTooltip: PropTypes.bool,
};
AButtonIconHelp.defaultProps = {
  icon: 'question-sign',
};
export default AButtonIconHelp;

